import { useCompactMoney } from "@/lib/useCompactMoney";
import { ReportShell, Section } from "./atoms";

export default function PnLView({ pnl, onExport, onShare }) {
  const { money } = useCompactMoney();
  return (
    <ReportShell title="Profit & Loss" kind="pnl" onExport={onExport} onShare={onShare} testid="pnl-view">
      <Section title="Revenue" rows={pnl.income} totalLabel="Total Revenue" totalValue={pnl.total_income} />
      <Section title="Cost of Goods Sold" rows={pnl.cogs} totalLabel="Total COGS" totalValue={pnl.total_cogs} />
      <div className="border-t-2 border-b border-[var(--ll-ink)] bg-[var(--ll-mint)] my-2 px-4 py-2.5 flex items-center justify-between">
        <div className="font-medium">Gross Profit</div>
        <div className="font-mono-fin font-medium">{money(pnl.gross_profit)}</div>
      </div>
      <Section title="Operating Expenses" rows={pnl.expense} totalLabel="Total Expenses" totalValue={pnl.total_expense} />
      <div className="bg-[#0b5d9e] text-white mt-4 px-4 py-3 flex items-center justify-between" data-testid="pnl-net-income">
        <div className="font-display font-bold text-lg">Net Income</div>
        <div className="font-mono-fin text-2xl">{money(pnl.net_income)}</div>
      </div>
    </ReportShell>
  );
}
